//TODO : Implement using ep themecolors rather than direct bg colors   
// --- ADD option to pass in Menu_ID (lookup from SDK call) or pass in menu json object
// figure out how to indicate if links are active based on current object.   
// Is that part of menu service?  Or defined in local javascript   "ItemActive": javascript function

// TODO:  How to pass parmeters to URLs   -- pull for parent object, concept of cmdline params (inv_session.current?)
// TODO:  Optimization  replaceParameters() called on menu change and parameter change.   
// Optimize so that only one called during init.    But either needs to trigger this on a change.

// TODO:   Rename URL in menu type to RouterLink?
// TODO:  refine Inputs.
// TODO:  Refine menu structure   strip "bg-" off of color?   strip  "fa" off of icon?    objectNode????

// TODO:  move parameter replacement to menu service
// TODO:  submenus?    separators?

// TODO: Add menu "title" property

import { Location, PlatformLocation } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { AppService } from '@Core/services/proprietary/app.service';
import { MenuService } from '@Core/services/proprietary/menu.service';
import { MenuLayoutType, MenuRuleType, MenuType } from '@Core/services/proprietary/menu.types';
import { TabService } from '@Core/services/proprietary/tab.service';
import { cloneDeep } from 'src/ep-utils';
import { EventType, PageState } from '@Core/models/proprietary/page/page.state';
import { DataService } from '../../../../../core/services/proprietary/data.service';
import _ from 'lodash';

@Component({
    standalone: false,
    selector: 'action-menu',
    templateUrl: './action-menu.component.html',
    styleUrls: ['./action-menu.component.css']
})
export class ActionMenuComponent implements OnInit, OnDestroy {
    private _menuData: MenuType = null;
    public dsMenu: MenuType = null;
    public cascadeMenu: any[] = [];
    private _parameters: any = {};

    MenuLayoutType = MenuLayoutType;

    @Input()
    set menuData(value: MenuType) {
        if (value && !value.objectNode) {
            //HACK -- current menu data structure is wrapped in "objectNode" element.   
            // We should change this post demo to not have the extra layer.   This code autofixes data without objectNode.
            value = { objectNode: cloneDeep(value) };
        }
        this._menuData = value;
        this.replaceParameters();
    }

    @Input()
    set menuCode(menuCode: string) {
        if (menuCode) {
            this.getMenu(menuCode);
        }
    }

    @Input()
    layout: MenuLayoutType = MenuLayoutType.TileBig;

    @Input()
    separator = 'row'; // row, inline, none

    @Input()
    columnClass = ''; // col-* / col-sm-*

    @Input()
    public set parameters(value: any) {
        this._parameters = value;
        this.replaceParameters();
    }

    @Input()
    tooltipPlacement: string = null;

    @Input()
    rootMenu: boolean = false;

    @Input()
    enabledInDesignerMode = false;

    @Output()
    actionSelected: EventEmitter<any>;

    @Output()
    menuItemSelected: EventEmitter<any>;

    @Select(PageState.readOnlyMode)
    readOnlyMode$: Observable<boolean>;

    @Select(PageState.protectedMode)
    protectedMode$: Observable<boolean>;

    @Select(PageState.dirty)
    pageDirty$: Observable<boolean>;

    @Select(PageState.validPermittedEvents)
    validEvents$: Observable<EventType[]>;

    readOnlyModeSub: Subscription;
    protectedModeSub: Subscription;
    pageDirtySub: Subscription;
    validEventsSub: Subscription;

    dirty: boolean = false;
    readOnly: boolean = false;
    protected: boolean = false;
    validEvents: EventType[] = [];

    get separatorDisplay(): string {
        switch (this.separator.toLowerCase()) {
            case 'none': // no separator
                return 'none';
            case 'inline': // display inline with menu options -- style for inline is not final!!!!
                return 'inline-block';
            case 'row': // new row for separator
                return 'block';
        }
        return 'block';
    }

    private replaceParameters() {
        if (this._menuData) {
            let temp: MenuType = cloneDeep(this._menuData); //copy object

            //loop through parameter array
            for (let parm in this._parameters) {
                if (this._parameters[parm]) {
                    //replace parameter in each menu item
                    for (let idx in temp.objectNode.Menu_Item) {
                        //if paramenter in the url parameter list then update value
                        // @ts-ignore: Unreachable code error
                        if (temp.objectNode.Menu_Item[idx].Url && temp.objectNode.Menu_Item[idx].Url[1].hasOwnProperty(parm)) {
                            // @ts-ignore: Unreachable code error
                            temp.objectNode.Menu_Item[idx].Url[1][parm] = this._parameters[parm];
                        }
                    }
                }
            }

            // TODO: Temp code. Once the Submission Track Option Menu is retrieved using MenuCollection instead of DB, this code can be removed.
            // The Menu is returned by DBQueryProcess and the JSON dictionary can't convert Flag to an array if there is a single value.
            for (let idx in temp.objectNode.Menu_Item) {
                if (temp.objectNode.Menu_Item[idx].Flag) {
                    if (!(temp.objectNode.Menu_Item[idx].Flag instanceof Array)) {
                        let singleFlag = _.clone(temp.objectNode.Menu_Item[idx].Flag);
                        let flagArray: any = [];
                        flagArray.push(singleFlag);
                        temp.objectNode.Menu_Item[idx].Flag = flagArray;
                    }
                }
            }

            this.dsMenu = temp;

            /******** Prototype for cascading launch menu *******/
            if (this.layout == MenuLayoutType.Cascade) {
                //converts menu into a multilevel menu structure -- separators at root and not separators children of closest separator
                let cascadeTemp = [];
                let currentRootMenu: number = -1;
                temp.objectNode.Menu_Item.forEach((menuItem) => {
                    if (menuItem.Type == 'separator') {
                        cascadeTemp.push({ ...menuItem, Child_Menu_Item: [] });
                        currentRootMenu++;
                    } else {
                        cascadeTemp[currentRootMenu].Child_Menu_Item.push(menuItem);
                    }
                });
                this.cascadeMenu = cascadeTemp;
            }
            /********** END Prototype *********/
        }
    }

    constructor(
        private menuService: MenuService,
        private app: AppService,
        private router: Router,
        private pLocation: PlatformLocation,
        private ds: DataService,
        private cdRef: ChangeDetectorRef,
        private tabService: TabService,
        private location: Location
    ) {
        this.actionSelected = new EventEmitter();
        this.menuItemSelected = new EventEmitter();
    }

    ngOnInit() {
        if (this.layout == MenuLayoutType.Toolbar || this.layout == MenuLayoutType.Hyperlink) {
            //create subscriptions to pagestate for hidden, disabled menu rules
            //TODO: we need to only create these subscription IF there are rules on the menu than need them. Basically need to keep this efficient
            //TODO: menu rules are only implemented on toolbar and hyperlink menus at present
            this.readOnlyModeSub = this.readOnlyMode$.subscribe((readOnlyValue) => {
                this.readOnly = readOnlyValue;
                this.cdRef.detectChanges();
            });
            this.protectedModeSub = this.protectedMode$.subscribe((protectedValue) => {
                this.protected = protectedValue;
                this.cdRef.detectChanges();
            });
            this.pageDirtySub = this.pageDirty$.subscribe((pageDirtyValue) => {
                this.dirty = pageDirtyValue;
            });
            this.validEventsSub = this.validEvents$.subscribe((validEventsValue) => {
                this.validEvents = validEventsValue;
            });
        }
    }

    ngOnDestroy() {
        if (this.readOnlyModeSub) {
            this.readOnlyModeSub.unsubscribe();
        }
        if (this.protectedModeSub) {
            this.protectedModeSub.unsubscribe();
        }
        if (this.pageDirtySub) {
            this.pageDirtySub.unsubscribe();
        }
        if (this.validEventsSub) {
            this.validEventsSub.unsubscribe();
        }
    }

    color(menuitem: any) {
        let color = 'secondary';
        if (menuitem && menuitem.Color) {
            color = menuitem.Color;
        }

        return color;
    }

    runAction(menuitem: any) {
        //console.log(menuitem);
        if (menuitem.Url) {
            let urlString: string = menuitem.Url[0] + '/';
            let segment: any[] = urlString.toLowerCase().split('/');
            if (segment[1] == 'action') {
                // emit local action rather than route to page
                // the url should be in the format of '/action/some-local-action-name'
                // Important to use this bind a menuHandler to the (actionSelected) output of the the menu control
                //emit object with Action_Code merged with optional url parameters
                this.actionSelected.emit({ Action_Code: segment[2], ...menuitem.Url[1] });
            } else {
                // send to page router

                if (this.rootMenu) {
                    menuitem.Url[1].Pass_Current_Info = 'Y';
                }
                if (menuitem.ObjectCode && menuitem.ObjectCode != null && menuitem.ObjectCode != '') {
                    menuitem.Url[1].Object_Code = menuitem.ObjectCode;
                }
                this.router.navigate(menuitem.Url);
            }
            this.menuItemSelected.emit();
        }
    }

    runActionInNewTab(event: any, menuitem: any) {
        if (menuitem.Url) {
            let urlString: string = menuitem.Url[0] + '/';
            let segment: any[] = urlString.toLowerCase().split('/');
            if (segment[1] == 'action') {
                // emit local action rather than route to page
                // the url should be in the format of '/action/some-local-action-name'
                // Important to use this bind a menuHandler to the (actionSelected) output of the the menu control
                //emit object with Action_Code merged with optional url parameters
                this.actionSelected.emit({ Action_Code: segment[2], ...menuitem.Url[1] });
            } else {
                // send to page router

                if (this.rootMenu) {
                    menuitem.Url[1].Pass_Current_Info = 'Y';
                }
                if (menuitem.ObjectCode && menuitem.ObjectCode != null && menuitem.ObjectCode != '') {
                    menuitem.Url[1].Object_Code = menuitem.ObjectCode;
                }

                let startRoute = menuitem.Url[0];
                let routeParams = { ...menuitem.Url[1] };
                let pageTitle = menuitem.Label;
                let newTabName = this.tabService.setTab(
                    startRoute,
                    routeParams,
                    pageTitle,
                    this.app.Username,
                    this.app.CurrentSystemCode
                );
                let newTabBasePath = this.tabService.getBasePath();
                let newTabUrl = newTabBasePath + '#' + '/newtab?TabID=' + newTabName;
                const tabRef = window.open(newTabUrl, newTabName);
                this.tabService.setTabObjRef(newTabName, tabRef);
            }
            this.menuItemSelected.emit();
        }
    }

    runActionInNewWindow(event: any, menuitem: any) {
        if (menuitem.Url) {
            let urlString: string = menuitem.Url[0] + '/';
            let segment: any[] = urlString.toLowerCase().split('/');
            if (segment[1] == 'action') {
                // emit local action rather than route to page
                // the url should be in the format of '/action/some-local-action-name'
                // Important to use this bind a menuHandler to the (actionSelected) output of the the menu control
                //emit object with Action_Code merged with optional url parameters
                this.actionSelected.emit({ Action_Code: segment[2], ...menuitem.Url[1] });
            } else {
                // send to page router

                if (this.rootMenu) {
                    menuitem.Url[1].Pass_Current_Info = 'Y';
                }
                if (menuitem.ObjectCode && menuitem.ObjectCode != null && menuitem.ObjectCode != '') {
                    menuitem.Url[1].Object_Code = menuitem.ObjectCode;
                }

                let startRoute = menuitem.Url[0];
                let routeParams = { ...menuitem.Url[1] };
                let pageTitle = menuitem.Label;
                let newWinName = this.tabService.setTab(
                    startRoute,
                    routeParams,
                    pageTitle,
                    this.app.Username,
                    this.app.CurrentSystemCode
                );
                let newWinBasePath = this.tabService.getBasePath();
                let newWinUrl = newWinBasePath + '#' + '/newtab?TabID=' + newWinName;
                let winOptions = this.tabService.getWindowOptions();
                window.open(newWinUrl, newWinName, winOptions);
            }
            this.menuItemSelected.emit();
        }
    }

    buildIDAttribute(menuitem: any) {
        if (menuitem && menuitem.Label) {
            return 'Menuitem' + menuitem.Label.replace(/[^\w]|_/g, ''); //all numbers/letters  (w is all numbers and letters and underscores )
        } else {
            return 'MenuitemUnknown';
        }
    }

    /** Aurora icon names match Unity sprite names once the `unity-icon-` prefix is stripped. */
    auroraIconName(icon: string): string {
        // Menu_Item.Icon is either a Font Awesome class or an icon name; tenant config may still
        // carry the legacy `unity-icon-` prefix, so accept both spellings.
        if (!icon || icon.startsWith('fa')) {
            return '';
        }
        return icon.replace('unity-icon-', '');
    }

    /** Menu_Item.Color carries legacy values such as `on_dark` that Aurora has no variant for. */
    auroraVariant(menuitem: any): string {
        const color = this.color(menuitem);
        return ['primary', 'secondary', 'tertiary', 'ghost'].includes(color) ? color : 'secondary';
    }

    //TODO: This may not be efficient enough.   We may need to preprocess rules and add properties to the menuitem
    checkLoading(menuitem: any): boolean {
        let rule: MenuRuleType[] = menuitem.Rules || [];
        if (rule.includes(MenuRuleType.DataLoadingSpinner)) {
            return this.ds.loadingCount > 0; //this.loading;
        }
        return false;
    }

    //TODO: This may not be efficient enough.   We may need to preprocess rules and add properties to the menuitem
    checkDirty(menuitem: any): boolean {
        let rule: MenuRuleType[] = menuitem.Rules || [];
        if (rule.includes(MenuRuleType.HighlightIfPageDirty)) {
            return this.dirty;
        }
        return false;
    }

    checkDisabled(menuitem: any): boolean {
        let rule: MenuRuleType[] = menuitem.Rules || [];

        if (rule.includes(MenuRuleType.Disable)) {
            return true;
        }

        if (this.app.DesignerMode && !this.enabledInDesignerMode) {
            return true;
        }

        if (rule.includes(MenuRuleType.DisableIfReadOnlyMode) && this.readOnly) {
            return true;
        }

        if (rule.includes(MenuRuleType.DisableIfEditMode) && !this.readOnly) {
            return true;
        }

        if (rule.includes(MenuRuleType.DisableIfEventInvalid_Delete) && !this.validEvents.includes(EventType.Delete)) {
            return true;
        }

        if (rule.includes(MenuRuleType.DisableIfEventInvalid_Update) && !this.validEvents.includes(EventType.Update)) {
            return true;
        }

        return false;
    }

    validMenuItem(menuitem: any): boolean {
        if (!menuitem) {
            return false;
        }
        let rule: MenuRuleType[] = menuitem.Rules || [];

        //TODO:  Would it be more efficient to loop through rule array and implement a case statement?

        if (rule.includes(MenuRuleType.Hide)) {
            return false;
        }

        if (rule.includes(MenuRuleType.HideIfReadOnlyMode) && this.readOnly) {
            return false;
        }

        if (rule.includes(MenuRuleType.HideIfProtectedMode) && this.protected) {
            return false;
        }

        if (rule.includes(MenuRuleType.HideIfEditMode) && !this.readOnly) {
            return false;
        }

        if (rule.includes(MenuRuleType.HideIfEventInvalid_Submit) && !this.validEvents.includes(EventType.Submit)) {
            return false;
        }

        if (rule.includes(MenuRuleType.HideIfEventInvalid_Accept) && !this.validEvents.includes(EventType.Accept)) {
            return false;
        }

        if (rule.includes(MenuRuleType.HideIfEventInvalid_Reject) && !this.validEvents.includes(EventType.Reject)) {
            return false;
        }

        if (rule.includes(MenuRuleType.HideIfEventInvalid_Void) && !this.validEvents.includes(EventType.Void)) {
            return false;
        }

        if (rule.includes(MenuRuleType.HideIfEventInvalid_Post) && !this.validEvents.includes(EventType.Post)) {
            return false;
        }

        if (rule.includes(MenuRuleType.HideIfEventInvalid_Send) && !this.validEvents.includes(EventType.Send)) {
            return false;
        }

        if (rule.includes(MenuRuleType.HideIfEventInvalid_Update) && !this.validEvents.includes(EventType.Update)) {
            return false;
        }

        if (rule.includes(MenuRuleType.HideIfEventInvalid_Delete) && !this.validEvents.includes(EventType.Delete)) {
            return false;
        }

        if (rule.includes(MenuRuleType.HideIfEventInvalid_Rate) && !this.validEvents.includes(EventType.Rate)) {
            return false;
        }

        if (rule.includes(MenuRuleType.HideIfEventInvalid_Approve) && !this.validEvents.includes(EventType.Approve)) {
            return false;
        }

        return true;
    }

    goBack() {
        this.location.back();
    }

    async getMenu(menuCode) {
        this.menuData = await this.menuService.getMenu(menuCode, false, false);
    }
}
